import { OrganizationLicense } from '../enums/account';
import { UserRole } from '../enums/userRoles';

// Invitation status enum
export enum InvitationStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  EXPIRED = 'expired',
  WITHDRAWN = 'withdrawn',
}

// Email sending status enum
export enum EmailStatus {
  PENDING = 'pending',
  SENT = 'sent',
  FAILED = 'failed',
}

// Invitation record from backend (token is excluded for security)
export interface TeamInvitation {
  id: string;
  email: string;
  role: UserRole;
  status: InvitationStatus;
  email_status: EmailStatus;
  email_error?: string;
  cirra_organization_id: string;
  organization_id: string;
  invited_by: string;
  invited_by_id: string;
  expires_at: string;
  accepted_at?: string;
  createdAt: string;
  updatedAt: string;
}

// Public invitation details (returned by getInvitationByToken)
export interface InvitationDetails {
  email: string;
  organization_name: string;
  inviter_email: string;
  role: UserRole;
  expires_at: string;
}

// UserInfo records from backend
export interface TeamUser {
  // Origin properties from backend
  id: string;
  cirra_user_id: string;
  cirra_organization_id: string;
  cirra_organization_name: string;
  role: UserRole;
  license: OrganizationLicense;
  createdAt: string;
  updatedAt: string;

  // Enhanced properties from `GET /v1/accounts/users/me/ability`
  ability?: Record<string, unknown>[];

  // Additional properties for frontend
  team: Team;
}

// UserInfo records from backend
export interface Team {
  // Origin properties from backend
  id: string;
  master_organization_id?: string;
  master_organization?: Team | null;
  cirra_organization_id: string;
  cirra_organization_name: string;
  stripe_customer_id: string | null;
  // When true, newly invited same-domain users are marked as team-only (no personal workspace)
  team_only_invitations?: boolean;
  // The primary email domain for team-only restrictions (e.g. "cirra.ai")
  primary_domain?: string;
  createdAt: string;
  updatedAt: string;

  // Additional properties for frontend
  current_user?: TeamUser;
}

export type TeamWithSubTeams = Team & {
  subTeams?: Team[];
};
